import React, {
  forwardRef,
  RefObject,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import Typography from "../../../../Foundation/Typography/Typography";
import FlexBox from "../../../FlexBox/FlexBox";
import NativeSelect from "../../../../Form/Select/NativeSelect";

interface IDeliveryDelayProps {
  label?: string;
  disabled?: boolean;
  dayPlaceholder?: string;
  dayValue?: string;
  timePlaceholder?: string;
  timeValue?: string;
  onChange?: (order_date: string, order_time: string) => void;
  dayList?: {
    label: string;
    value: string;
  }[];
  timeList?: {
    label: string;
    value: string;
  }[];

  preset?: {
    day?: string;
    time?: string;
  };
  style?: React.CSSProperties;
}

type DeliveryDelayRefs = {
  selectDayRef: RefObject<HTMLSelectElement>;
  selectTimeRef: RefObject<HTMLSelectElement>;
};

const DeliveryDelay = forwardRef<DeliveryDelayRefs, IDeliveryDelayProps>(
  (props, ref) => {
    const {
      label,
      disabled,
      dayValue = "",
      timeValue = "",
      dayList = [],
      timeList = [],
      dayPlaceholder = "",
      timePlaceholder = "",
      preset,
      onChange,
      style,
    } = props;
    const [time, setTime] = useState<string>(timeValue);
    const [day, setDay] = useState<string>(dayValue);

    const selectDayRef = useRef<HTMLSelectElement>(null);
    const selectTimeRef = useRef<HTMLSelectElement>(null);
    useImperativeHandle(ref, () => ({
      selectDayRef,
      selectTimeRef,
    }));

    useEffect(() => {
      onChange && !!day && onChange(day, time);
    }, [time, day]);

    useEffect(() => {
      const { day = "", time = "" } = { ...preset };
      setDay(day);
      setTime(time);
      console.log("change preset", day, time);
      if (!!selectTimeRef.current) selectTimeRef.current.value = time;
      if (!!selectDayRef.current) selectDayRef.current.value = day;
    }, [preset]);

    return (
      <FlexBox
        direction="column"
        gap={10}
        style={
          disabled
            ? {
                opacity: 0.3,
                pointerEvents: "none",
                cursor: "not-allowed",
                ...style,
              }
            : style
        }
      >
        <Typography variant="h7" color="black">
          {label}
        </Typography>
        <FlexBox gap={14} wrap={"wrap"}>
          <NativeSelect
            ref={selectDayRef}
            defaultValue={day}
            placeholder={dayPlaceholder}
            options={dayList}
            style={{ flex: 1 }}
            required
            onChange={(e) => setDay(e.target.value)}
          />
          <NativeSelect
            ref={selectTimeRef}
            defaultValue={time}
            placeholder={timePlaceholder}
            options={timeList}
            style={{ flex: 1 }}
            required
            onChange={(e) => setTime(e.target.value)}
          />
        </FlexBox>
      </FlexBox>
    );
  }
);

export default DeliveryDelay;
